export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Поиск"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Нажмите для выбора отображаемых столбцов"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Отображаемые столбцы"])}
}